export default "__VITE_ASSET__2651f260__"